import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵdefineComponent, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, Component, ɵɵinject, Inject, ɵɵelement, ɵɵproperty, ɵɵdirectiveInject, ɵɵtemplate, ɵɵgetCurrentView, ɵɵlistener, ɵɵrestoreView, ɵɵnextContext, ɵɵadvance, ɵɵpureFunction1, ɵɵtextInterpolate1, EventEmitter, ɵɵNgOnChangesFeature, Input, Output, ɵɵpropertyInterpolate, ɵɵtextInterpolate2, ɵɵcontentQuery, TemplateRef, ɵɵqueryRefresh, ɵɵloadQuery, ContentChild, ɵɵdefineDirective, Directive, HostListener, ɵɵviewQuery, ViewChild, ɵɵtextInterpolate, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { HttpHeaders, HttpClient, HttpClientModule } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { trigger, transition, style, animate } from '@angular/animations';
import { NgIf, NgForOf, NgStyle, NgTemplateOutlet, NgClass, CommonModule } from '@angular/common';
import { Subject as Subject$1 } from 'rxjs/';
import { ToastrService } from 'ngx-toastr';
import { NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, CheckboxControlValueAccessor, NgModel, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HubConnectionBuilder } from '@aspnet/signalr';

class ServiceCommonService {
    constructor() { }
}
ServiceCommonService.ɵfac = function ServiceCommonService_Factory(t) { return new (t || ServiceCommonService)(); };
ServiceCommonService.ɵprov = ɵɵdefineInjectable({ token: ServiceCommonService, factory: ServiceCommonService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ServiceCommonService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class ServiceCommonComponent {
    constructor() { }
    ngOnInit() {
    }
}
ServiceCommonComponent.ɵfac = function ServiceCommonComponent_Factory(t) { return new (t || ServiceCommonComponent)(); };
ServiceCommonComponent.ɵcmp = ɵɵdefineComponent({ type: ServiceCommonComponent, selectors: [["lib-service-common"]], decls: 2, vars: 0, template: function ServiceCommonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "p");
        ɵɵtext(1, " service-common works! ");
        ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ServiceCommonComponent, [{
        type: Component,
        args: [{
                selector: 'lib-service-common',
                template: `
    <p>
      service-common works!
    </p>
  `,
                styles: []
            }]
    }], function () { return []; }, null); })();

class FormValidationService {
    // private lastInserted: number[] = [];
    constructor() {
    }
    BindServerErrors(formGroup, rejected) {
        try {
            Object.keys(rejected.errors).forEach(prop => {
                let fieldName = prop[0].toLocaleLowerCase() + prop.substr(1, prop.length);
                fieldName = fieldName.split('.')[fieldName.split('.').length - 1];
                Object.keys(formGroup.controls).forEach(key => {
                    if (fieldName.toLocaleLowerCase() == key.toLocaleLowerCase()) {
                        const formControl = formGroup.get(key);
                        if (formControl) {
                            formControl.setErrors({ serverError: rejected.errors[prop][0] });
                        }
                    }
                });
            });
        }
        catch (_error) {
            Object.keys(rejected.error.errors).forEach(prop => {
                let fieldName = prop[0].toLocaleLowerCase() + prop.substr(1, prop.length);
                fieldName = fieldName.split('.')[fieldName.split('.').length - 1];
                Object.keys(formGroup.controls).forEach(key => {
                    if (fieldName.toLocaleLowerCase() == key.toLocaleLowerCase()) {
                        const formControl = formGroup.get(key);
                        if (formControl) {
                            formControl.setErrors({ serverError: rejected.error.errors[prop][0] });
                        }
                    }
                    // else if(fieldName.toLocaleLowerCase().indexOf(key.toLocaleLowerCase()) > -1){
                    //     const formControl = formGroup.get(key);
                    //     if (formControl) {
                    //         formControl.setErrors({ serverError: rejected.error.errors[prop][0] });
                    //     }
                    // }
                });
            });
        }
    }
}
FormValidationService.ɵfac = function FormValidationService_Factory(t) { return new (t || FormValidationService)(); };
FormValidationService.ɵprov = ɵɵdefineInjectable({ token: FormValidationService, factory: FormValidationService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FormValidationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class RestService {
    constructor(http, domainid) {
        this.http = http;
        this.domainid = domainid;
    }
    Get(path) {
        const token = localStorage.getItem('authenticationtoken');
        this.header = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        });
        return this.http.get(path, { headers: this.header });
    }
    post(path, entity) {
        const token = localStorage.getItem('authenticationtoken');
        this.header = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        });
        return this.http.post(path, entity, { headers: this.header });
    }
    put(path, entity) {
        const token = localStorage.getItem('authenticationtoken');
        this.header = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        });
        return this.http.put(path, entity, { headers: this.header });
    }
    delete(path) {
        const token = localStorage.getItem('authenticationtoken');
        this.header = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        });
        return this.http.delete(path, { headers: this.header });
    }
    postXmlHttp(path, data, callback, error) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', path);
        xhr.addEventListener("readystatechange", function () {
            if (this.readyState === 4) {
                callback(JSON.parse(xhr.response));
            }
        });
        xhr.onerror = function (ex) {
            error(ex);
        };
        xhr.timeout = 0;
        xhr.setRequestHeader("content-type", "application/json");
        xhr.setRequestHeader("Authorization", "Bearer " + localStorage.getItem("authenticationtoken") + "");
        xhr.send(JSON.stringify(data));
    }
}
RestService.ɵfac = function RestService_Factory(t) { return new (t || RestService)(ɵɵinject(HttpClient), ɵɵinject('domainid')); };
RestService.ɵprov = ɵɵdefineInjectable({ token: RestService, factory: RestService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RestService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['domainid']
            }] }]; }, null); })();

class EnvironmentService {
    constructor(http, window, router) {
        this.http = http;
        this.window = window;
        this.router = router;
    }
    // get data object from script in Index.cshtml
    get environmentData() {
        return this.window;
    }
    get authServerUrl() {
        return this.getValue('authServe');
    }
    get appTitle() {
        return this.getValue('AppTitle');
    }
    get clientId() {
        return this.getValue('Clientid');
    }
    get logoUrl() {
        return this.getValue('AppLogo');
    }
    get AppUrl() {
        return this.getValue('AppUrl');
    }
    get GrantType() {
        return this.getValue('GrantType');
    }
    get ClientSecret() {
        return this.getValue('ClientSecret');
    }
    get Scope() {
        return this.getValue('Scope');
    }
    get ApiGateway() {
        return this.getValue('ApiGateway');
    }
    get FullStockUrl() {
        return this.getValue('ApiAdmin');
    }
    get AppName() {
        return this.getValue('AppName');
    }
    get DomainId() {
        return this.getValue('domainid');
    }
    get returnUrl() {
        return this._returnUrl;
    }
    set returnUrl(v) {
        this._returnUrl = v;
    }
    get Authtoken() {
        return localStorage.getItem('authenticationtoken');
    }
    set Authtoken(v) {
        localStorage.setItem('authenticationtoken', v);
    }
    get IsLogin() {
        // return this.CheckLogin();
        let flag = false;
        const _thiscomp = this;
        try {
            const request = new XMLHttpRequest();
            request.open('GET', this.ApiGateway + '/IsLoggedIn', false); // `false` makes the request synchronous
            request.setRequestHeader('Authorization', 'Bearer ' + _thiscomp.Authtoken);
            request.send(null);
            if (request.status === 200) {
                flag = true;
            }
        }
        catch (error) {
        }
        return flag;
    }
    get IsGuestLogin() {
        // return this.CheckGuestLogin();
        let flag = false;
        const _thiscomp = this;
        try {
            const request = new XMLHttpRequest();
            request.open('GET', this.ApiGateway + '/IsGuestLoggedIn', false); // `false` makes the request synchronous
            request.setRequestHeader('Authorization', 'Bearer ' + _thiscomp.Authtoken);
            request.send(null);
            if (request.status === 200) {
                flag = true;
            }
        }
        catch (error) {
        }
        return flag;
    }
    get IsAdminLogin() {
        // return this.CheckGuestLogin();
        let flag = false;
        const _thiscomp = this;
        const request = new XMLHttpRequest();
        request.open('GET', this.ApiGateway + '/Admin/IsLoggedIn', false); // `false` makes the request synchronous
        request.setRequestHeader('Authorization', 'Bearer ' + _thiscomp.Authtoken);
        request.send(null);
        if (request.status === 200) {
            flag = true;
        }
        return flag;
    }
    get RoleModuleAccessList() {
        if (localStorage.RoleModuleAccessList == null || localStorage.RoleModuleAccessList == undefined) {
            return null;
        }
        else {
            return JSON.parse(localStorage.getItem('RoleModuleAccessList').toString());
        }
    }
    set RoleModuleAccessList(v) {
        localStorage.setItem('RoleModuleAccessList', JSON.stringify(v));
    }
    get UserModuleAccessList() {
        if (localStorage.UserModuleAccessList == null || localStorage.UserModuleAccessList == undefined) {
            return null;
        }
        else {
            return JSON.parse(localStorage.getItem('UserModuleAccessList').toString());
        }
    }
    set UserModuleAccessList(v) {
        localStorage.setItem('UserModuleAccessList', JSON.stringify(v));
    }
    get searchStock() {
        try {
            return JSON.parse(localStorage.getItem('searchStock')).filterData;
        }
        catch (error) {
            return null;
        }
    }
    get searchStockData() {
        return JSON.parse(localStorage.getItem('searchStock'));
    }
    set searchStockData(data) {
        localStorage.setItem('searchStock', data);
    }
    getValue(key) {
        if (!this.environmentData) {
            console.error('please set environment-variables');
            return null;
        }
        if (!this.environmentData[key]) {
            console.error(`please set environment-variable ${key}`);
            return null;
        }
        return this.environmentData[key];
    }
    CheckLogin() {
        let returnflag;
        const header = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + this.Authtoken
        });
        this.http.get(this.ApiGateway + '/IsLoggedIn', { headers: header }).toPromise().then(result => returnflag = true, error => {
            this.CheckGuestLogin();
        });
        return returnflag;
    }
    CheckGuestLogin() {
        let returnflag;
        const header = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + this.Authtoken
        });
        this.http.get(this.ApiGateway + '/IsGuestLoggedIn', { headers: header }).toPromise().then(result => returnflag = true, error => {
            location.reload();
        });
        return returnflag;
    }
    GetModuleAcccess() {
        // return this.CheckGuestLogin();
        let flag = false;
        const _thiscomp = this;
        const request = new XMLHttpRequest();
        request.open('GET', this.ApiGateway + '/admin/RoleModuleAccess/LoadbyModule', false); // `false` makes the request synchronous
        request.setRequestHeader('Authorization', 'Bearer ' + _thiscomp.Authtoken);
        request.send(null);
        if (request.status === 200) {
            flag = true;
            _thiscomp.RoleModuleAccessList = JSON.parse(request.responseText);
        }
        this.GetUserModuleAcccess();
        return flag;
    }
    GetUserModuleAcccess() {
        // return this.CheckGuestLogin();
        let flag = false;
        const _thiscomp = this;
        const request = new XMLHttpRequest();
        request.open('GET', this.ApiGateway + '/admin/UserRoleAccess/GetAccess', false); // `false` makes the request synchronous
        request.setRequestHeader('Authorization', 'Bearer ' + _thiscomp.Authtoken);
        request.send(null);
        if (request.status === 200) {
            flag = true;
            _thiscomp.UserModuleAccessList = JSON.parse(request.responseText);
        }
        this.GetSearchStockAccess();
        return flag;
    }
    GetSearchStockAccess() {
        // return this.CheckGuestLogin();
        let flag = false;
        const _thiscomp = this;
        const request = new XMLHttpRequest();
        request.open('GET', this.ApiGateway + '/admin/UserSearchCriteria/LoadByCurrentUser', false); // `false` makes the request synchronous
        request.setRequestHeader('Authorization', 'Bearer ' + _thiscomp.Authtoken);
        request.send(null);
        if (request.status === 200) {
            flag = true;
            _thiscomp.searchStockData = request.responseText;
        }
        return flag;
    }
    CheckModuleAccess(ModuleName, Action) {
        // return this.CheckGuestLogin();
        let flag = false;
        const _thiscomp = this;
        const request = new XMLHttpRequest();
        request.open('GET', this.ApiGateway + '/Admin/CheckModuleActionAccess?ModuleName=' + ModuleName + '&Action=' + Action, false); // `false` makes the request synchronous
        request.setRequestHeader('Authorization', 'Bearer ' + _thiscomp.Authtoken);
        request.send(null);
        if (request.status === 200) {
            flag = true;
        }
        return flag;
    }
    logout() {
        this.Authtoken = null;
        this.router.navigateByUrl('/auth/login');
        localStorage.clear();
    }
}
EnvironmentService.ɵfac = function EnvironmentService_Factory(t) { return new (t || EnvironmentService)(ɵɵinject(HttpClient), ɵɵinject('Window'), ɵɵinject(Router)); };
EnvironmentService.ɵprov = ɵɵdefineInjectable({ token: EnvironmentService, factory: EnvironmentService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(EnvironmentService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['Window']
            }] }, { type: Router }]; }, null); })();

class loaderBroadcastEventCls {
    constructor(hidden) {
        this.hidden = hidden;
    }
}
class loaderBroadcaster {
    constructor() {
        this._eventBus = new Subject();
    }
    broadcast(data) {
        this._eventBus.next(data);
    }
    on() {
        return this._eventBus.asObservable();
    }
}

class loaderserice {
    constructor(_Broadcaster) {
        this._Broadcaster = _Broadcaster;
    }
    show(hidden) {
        try {
            this._Broadcaster.broadcast(hidden);
        }
        catch (e) {
        }
    }
}
loaderserice.ɵfac = function loaderserice_Factory(t) { return new (t || loaderserice)(ɵɵinject(loaderBroadcaster)); };
loaderserice.ɵprov = ɵɵdefineInjectable({ token: loaderserice, factory: loaderserice.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(loaderserice, [{
        type: Injectable
    }], function () { return [{ type: loaderBroadcaster }]; }, null); })();

function loader_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 1);
    ɵɵelement(1, "img", 2);
    ɵɵelement(2, "img", 3);
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵproperty("@inOutAnimation", undefined);
} }
class loader {
    constructor(broadcat) {
        this.broadcat = broadcat;
        this._hidden = false;
    }
    ngOnInit() {
        this.broadcat.on().subscribe(data => this.setDataSuccess(data));
    }
    setDataSuccess(data) {
        this._hidden = data;
    }
}
loader.ɵfac = function loader_Factory(t) { return new (t || loader)(ɵɵdirectiveInject(loaderBroadcaster)); };
loader.ɵcmp = ɵɵdefineComponent({ type: loader, selectors: [["app-loader"]], decls: 1, vars: 1, consts: [["style", "left:0px;top:0px;position:fixed; padding-left: 17px;width:100%;height:100%;z-index:99999;    background-color: #192b4a;text-align: center;", 4, "ngIf"], [2, "left", "0px", "top", "0px", "position", "fixed", "padding-left", "17px", "width", "100%", "height", "100%", "z-index", "99999", "background-color", "#192b4a", "text-align", "center"], ["src", "/assets/logos/CDinesh-Logo-Layers.gif", 1, "desk-view", 2, "left", "46%", "position", "absolute", "top", "45%", "width", "100px"], ["src", "/assets/logos/CDinesh-Logo-Layers.gif", 1, "mobile-view", 2, "margin-top", "50%", "width", "100px"]], template: function loader_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, loader_div_0_Template, 3, 1, "div", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx._hidden);
    } }, directives: [NgIf], encapsulation: 2, data: { animation: [
            trigger('inOutAnimation', [
                transition(':enter', [
                    style({ opacity: 0 }),
                    animate('1s ease-out', style({ opacity: 1 }))
                ]),
                transition(':leave', [
                    style({ opacity: 1 }),
                    animate('1s ease-in', style({ opacity: 0 }))
                ])
            ])
        ] } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(loader, [{
        type: Component,
        args: [{
                selector: 'app-loader',
                templateUrl: '../loader/loader.html',
                animations: [
                    trigger('inOutAnimation', [
                        transition(':enter', [
                            style({ opacity: 0 }),
                            animate('1s ease-out', style({ opacity: 1 }))
                        ]),
                        transition(':leave', [
                            style({ opacity: 1 }),
                            animate('1s ease-in', style({ opacity: 0 }))
                        ])
                    ])
                ]
            }]
    }], function () { return [{ type: loaderBroadcaster }]; }, null); })();

class alertBroadcastEventCls {
    constructor(key, title, msg, data) {
        this.key = key;
        this.title = title;
        this.msg = msg;
        this.data = data;
    }
}
class AltBroadcaster {
    constructor() {
        this._eventBus = new Subject$1();
    }
    broadcast(data) {
        this._eventBus.next(data);
    }
    on() {
        return this._eventBus.asObservable();
    }
}

class alertserice {
    constructor(_Broadcaster) {
        this._Broadcaster = _Broadcaster;
        this._alertBroadcastEvent = new alertBroadcastEventCls('', '');
    }
    success(title, message) {
        try {
            this._alertBroadcastEvent.msg = message;
            this._alertBroadcastEvent.title = title;
            this._alertBroadcastEvent.key = 'success';
            this._Broadcaster.broadcast(JSON.stringify(this._alertBroadcastEvent));
        }
        catch (e) {
            console.error(e);
        }
    }
    Error(title, message) {
        try {
            this._alertBroadcastEvent.msg = message;
            this._alertBroadcastEvent.title = title;
            this._alertBroadcastEvent.key = 'error';
            this._Broadcaster.broadcast(JSON.stringify(this._alertBroadcastEvent));
        }
        catch (e) {
        }
    }
}
alertserice.ɵfac = function alertserice_Factory(t) { return new (t || alertserice)(ɵɵinject(AltBroadcaster)); };
alertserice.ɵprov = ɵɵdefineInjectable({ token: alertserice, factory: alertserice.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(alertserice, [{
        type: Injectable
    }], function () { return [{ type: AltBroadcaster }]; }, null); })();

class alert {
    constructor(broadcat, toastr) {
        this.broadcat = broadcat;
        this.toastr = toastr;
        this._hidden = true;
        this.MegBoxType = '';
    }
    ngOnInit() {
        this.broadcat.on().subscribe(data => this.setDataSuccess(data));
    }
    setDataSuccess(values) {
        let data = JSON.parse(values);
        this.title = data.title;
        this.privatemessage = data.msg;
        this.MegBoxType = data.key;
        if (this.MegBoxType == 'success') {
            this.toastr.toastrConfig.autoDismiss = true;
            this.toastr.toastrConfig.timeOut = 5000;
            this.toastr.success(this.privatemessage, this.title);
        }
        else if (this.MegBoxType == 'error') {
            this.toastr.toastrConfig.autoDismiss = false;
            this.toastr.error(this.privatemessage, this.title);
        }
        // this._hidden = false;
    }
    close() {
        this.MegBoxType = '';
    }
}
alert.ɵfac = function alert_Factory(t) { return new (t || alert)(ɵɵdirectiveInject(AltBroadcaster), ɵɵdirectiveInject(ToastrService)); };
alert.ɵcmp = ɵɵdefineComponent({ type: alert, selectors: [["alert"]], decls: 0, vars: 0, template: function alert_Template(rf, ctx) { }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(alert, [{
        type: Component,
        args: [{
                selector: 'alert',
                templateUrl: '../alert/Alert.html'
            }]
    }], function () { return [{ type: AltBroadcaster }, { type: ToastrService }]; }, null); })();

class DropDownService extends RestService {
    constructor(http, env) {
        super(http);
        this.http = http;
        this.env = env;
    }
    loadData(path) {
        return super.Get(this.env.ApiGateway + '/' + path);
    }
}
DropDownService.ɵfac = function DropDownService_Factory(t) { return new (t || DropDownService)(ɵɵinject(HttpClient), ɵɵinject(EnvironmentService)); };
DropDownService.ɵprov = ɵɵdefineInjectable({ token: DropDownService, factory: DropDownService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DropDownService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }, { type: EnvironmentService }]; }, null); })();

function CDDropdownComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 4);
    ɵɵelement(1, "img", 5);
    ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "background-color": a0 }; };
function CDDropdownComponent_div_3_tr_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "tr", 9);
    ɵɵelementStart(1, "td", 10);
    ɵɵlistener("click", function CDDropdownComponent_div_3_tr_2_Template_td_click_1_listener() { ɵɵrestoreView(_r6); const x_r3 = ctx.index; const ctx_r5 = ɵɵnextContext(2); return ctx_r5.mouseclick(x_r3); });
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const x_r3 = ctx.index;
    const item_r4 = ctx.$implicit;
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngStyle", ɵɵpureFunction1(2, _c0, x_r3 == ctx_r2.currentIndex ? "grey" : ""));
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", item_r4[ctx_r2.displaymember], " ");
} }
function CDDropdownComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 6);
    ɵɵelementStart(1, "table", 7);
    ɵɵtemplate(2, CDDropdownComponent_div_3_tr_2_Template, 3, 4, "tr", 8);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", ctx_r1.data);
} }
class CDDropdownComponent {
    constructor(dropDownService) {
        this.dropDownService = dropDownService;
        this.showDropdown = false;
        this.currentIndex = 0;
        this.change = new EventEmitter();
        this.scrollHeight = 0;
        this.showloading = false;
        this.valChange = false;
    }
    ngOnChanges(changes) {
        this.returnVal = this._value;
        if (this.entitypath == null || this.entitypath == undefined || this.entitypath == '') {
            return;
        }
        if (this.returnkey != null && this.returnkey != undefined) {
            this.showloading = true;
            this.dropDownService.loadData(this.entitypath + '?id=' + this.returnkey).subscribe(result => {
                this.showloading = false;
                try {
                    this.data = [];
                    this.data.push(result);
                    this._value = this.data[0][this.displaymember];
                    this.change.emit({ id: this.returnkey, value: this._value });
                }
                catch (error) {
                }
            }, error => {
                this.showloading = false;
                console.error(error);
            });
        }
    }
    ngOnInit() {
        this.data = [];
        this.loadData();
    }
    keypress(event) {
        if (this.showDropdown == false) {
            this.showDropdown = true;
            return;
        }
        if (event.keyCode == 38) { // up key
            if (this.currentIndex > 0) {
                this.currentIndex = this.currentIndex - 1;
            }
            else {
                this.currentIndex = this.data.length - 1;
            }
        }
        else if (event.keyCode == 40) { // down key
            if (this.data.length - 1 > this.currentIndex) {
                this.currentIndex = this.currentIndex + 1;
            }
            else {
                this.currentIndex = 0;
            }
        }
        else if (event.keyCode == 37) { // left key
        }
        else if (event.keyCode == 39) { // right key
        }
        else if (event.keyCode == 45) { // delete key
        }
        else if (event.keyCode == 46) { // insert key
        }
        else if (event.shiftKey) { // shift key
        }
        else if (event.altKey) { // alt key
        }
        else if (event.ctrlKey) { // ctrl key
        }
        else if (event.metaKey) { // meta key
        }
        else if (event.keyCode == 120) { // home key
        }
        else if (event.keyCode == 121) { // end key
        }
        else {
            this.loadData();
        }
    }
    keydown(event) {
        if (event.key === 'Enter') {
            const frm = this;
            if (frm.data.length > 0) {
                try {
                    frm.returnkey = frm.data[this.currentIndex][this.valueMember];
                    frm.returnVal = frm.data[this.currentIndex][this.displaymember];
                    frm._value = frm.data[this.currentIndex][this.displaymember];
                }
                catch (error) {
                }
                frm.showDropdown = false;
                frm.change.emit({ id: frm.returnkey, value: frm._value });
            }
            else {
                frm.showDropdown = false;
                frm.change.emit({ id: null, value: frm._value });
            }
            event.stopPropagation();
            return false;
        }
    }
    loadData() {
        this.showloading = true;
        this.dropDownService.loadData(this.path + '?searchText=' + encodeURIComponent(this._value + (this.params == undefined ? '' : this.params))).subscribe(result => {
            this.showloading = false;
            this.data = result;
        }, error => {
            this.showloading = true;
            console.error(error);
        });
    }
    mouseclick(index) {
        this.currentIndex = index;
        const frm = this;
        if (frm.data.length > 0) {
            try {
                frm.returnkey = frm.data[this.currentIndex][this.valueMember];
                frm.returnVal = frm.data[this.currentIndex][this.displaymember];
                frm._value = frm.data[this.currentIndex][this.displaymember];
            }
            catch (error) {
            }
            frm.showDropdown = false;
            frm.change.emit({ id: frm.returnkey, value: frm._value });
        }
        else {
            frm.change.emit({ id: null, value: frm._value });
        }
    }
    focusout() {
        const frm = this;
        setTimeout(() => {
            if (frm.data.length > 0 && frm._value != '' && frm._value != undefined) {
                try {
                    frm.returnkey = frm.data[this.currentIndex][this.valueMember];
                    frm.returnVal = frm.data[this.currentIndex][this.displaymember];
                    frm._value = frm.data[this.currentIndex][this.displaymember];
                }
                catch (error) {
                }
                frm.showDropdown = false;
                frm.change.emit({ id: frm.returnkey, value: frm._value });
            }
            else {
                frm.showDropdown = false;
                frm.change.emit({ id: null, value: frm._value });
            }
        }, 100);
    }
    scrollPosFunction() {
        try {
            const elmnt = document.getElementById('ctmdropdown');
            this.scrollHeight = elmnt.scrollHeight;
            if (this.scrollHeight > 0 && this.data.length > 0) {
                const eachComponentHeight = this.scrollHeight / this.data.length;
                document.getElementById('ctmdropdown').scrollTop = eachComponentHeight * this.currentIndex;
            }
        }
        catch (error) {
            console.log(error);
        }
    }
}
CDDropdownComponent.ɵfac = function CDDropdownComponent_Factory(t) { return new (t || CDDropdownComponent)(ɵɵdirectiveInject(DropDownService)); };
CDDropdownComponent.ɵcmp = ɵɵdefineComponent({ type: CDDropdownComponent, selectors: [["lib-cddropdown"]], inputs: { returnkey: ["modelkey", "returnkey"], returnVal: ["modelvalue", "returnVal"], path: "path", entitypath: "entitypath", params: "params", valueMember: ["valuemember", "valueMember"], displaymember: "displaymember", form: "form", _formcontrolname: ["formcontrolname", "_formcontrolname"] }, outputs: { change: "change" }, features: [ɵɵNgOnChangesFeature], decls: 4, vars: 6, consts: [[3, "formGroup"], ["type", "text", "aria-autocomplete", "none", "autocomplete", "none", 1, "form-control", 3, "formControlName", "name", "ngModel", "ngModelChange", "focusout", "keyup", "keydown"], ["style", "position: absolute;;z-index: 1000000;right: 15px;top:30px;", 4, "ngIf"], ["id", "ctmdropdown", "style", "position: absolute;width: 300px;overflow-y: auto;overflow-x: hidden;max-height: 300px;z-index: 1000000;background-color: wheat;", 4, "ngIf"], [2, "position", "absolute", ";z-index", "1000000", "right", "15px", "top", "30px"], ["width", "30", "height", "30", "src", "/assets/img/small.loading.gif"], ["id", "ctmdropdown", 2, "position", "absolute", "width", "300px", "overflow-y", "auto", "overflow-x", "hidden", "max-height", "300px", "z-index", "1000000", "background-color", "wheat"], [2, "width", "100%"], ["style", "cursor: pointer;", 4, "ngFor", "ngForOf"], [2, "cursor", "pointer"], [2, "cursor", "pointer", "text-align", "left !important", 3, "ngStyle", "click"]], template: function CDDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "input", 1);
        ɵɵlistener("ngModelChange", function CDDropdownComponent_Template_input_ngModelChange_1_listener($event) { return ctx._value = $event; })("focusout", function CDDropdownComponent_Template_input_focusout_1_listener() { return ctx.focusout(); })("keyup", function CDDropdownComponent_Template_input_keyup_1_listener($event) { return ctx.keypress($event); })("keydown", function CDDropdownComponent_Template_input_keydown_1_listener($event) { return ctx.keydown($event); });
        ɵɵelementEnd();
        ɵɵtemplate(2, CDDropdownComponent_div_2_Template, 2, 0, "div", 2);
        ɵɵtemplate(3, CDDropdownComponent_div_3_Template, 3, 1, "div", 3);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(1);
        ɵɵproperty("formControlName", ctx._formcontrolname)("name", ctx._formcontrolname)("ngModel", ctx._value);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showloading);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showDropdown);
    } }, directives: [NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, NgIf, NgForOf, NgStyle], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CDDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'lib-cddropdown',
                templateUrl: './cddropdown.component.html',
                styleUrls: ['./cddropdown.component.css']
            }]
    }], function () { return [{ type: DropDownService }]; }, { returnkey: [{
            type: Input,
            args: ['modelkey']
        }], returnVal: [{
            type: Input,
            args: ['modelvalue']
        }], path: [{
            type: Input,
            args: ['path']
        }], entitypath: [{
            type: Input,
            args: ['entitypath']
        }], params: [{
            type: Input,
            args: ['params']
        }], valueMember: [{
            type: Input,
            args: ['valuemember']
        }], displaymember: [{
            type: Input,
            args: ['displaymember']
        }], form: [{
            type: Input
        }], _formcontrolname: [{
            type: Input,
            args: ['formcontrolname']
        }], change: [{
            type: Output
        }] }); })();

function CdmulitselectComponent_span_2_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "span", 10);
    ɵɵelementStart(1, "span", 11);
    ɵɵelementStart(2, "span", 12);
    ɵɵlistener("click", function CdmulitselectComponent_span_2_span_1_Template_span_click_2_listener() { ɵɵrestoreView(_r5); const myitem_r3 = ctx.$implicit; const ctx_r4 = ɵɵnextContext(2); return ctx_r4.removeselectedItem(myitem_r3); });
    ɵɵtext(3, "\u00D7");
    ɵɵelementEnd();
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const myitem_r3 = ctx.$implicit;
    ɵɵadvance(4);
    ɵɵtextInterpolate1(" ", myitem_r3.name, " ");
} }
function CdmulitselectComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtemplate(1, CdmulitselectComponent_span_2_span_1_Template, 5, 1, "span", 9);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r0.selectedItem);
} }
const _c0$1 = function (a0) { return { "background-color": a0 }; };
function CdmulitselectComponent_tr_8_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "tr", 13);
    ɵɵlistener("click", function CdmulitselectComponent_tr_8_Template_tr_click_0_listener() { ɵɵrestoreView(_r9); const x_r6 = ctx.index; const ctx_r8 = ɵɵnextContext(); return ctx_r8.mouseclick(x_r6); });
    ɵɵelementStart(1, "td", 14);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const x_r6 = ctx.index;
    const item_r7 = ctx.$implicit;
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngStyle", ɵɵpureFunction1(2, _c0$1, x_r6 == ctx_r1.currentIndex ? "grey" : ""));
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", item_r7[ctx_r1.displaymember], " ");
} }
class CdmulitselectComponent {
    constructor() {
        this._value = '';
        this.showDropdown = false;
        this.currentIndex = 0;
        this.change = new EventEmitter();
        this.scrollHeight = 0;
        this.controlName = 'my' + Math.floor(Math.random() * 100);
    }
    ngOnChanges(changes) {
        try {
            this.filterdata = this.data;
            if (this.returnkey != undefined && this.data != undefined) {
                this.selectedItem = [];
                let valary = this.returnkey.split(',');
                valary.forEach(element => {
                    try {
                        let item = this.data.filter(x => x[this.valueMember] == element)[0];
                        this.selectedItem.push({ id: item[this.valueMember], name: item[this.displaymember] });
                        let _returndata = '';
                        for (let i = 0; i < this.selectedItem.length; i++) {
                            const element = this.selectedItem[i];
                            if (_returndata == '') {
                                _returndata = this.selectedItem[i][this.valueMember];
                            }
                            else {
                                _returndata = _returndata + ',' + this.selectedItem[i][this.valueMember];
                            }
                        }
                        this.returndata = _returndata;
                    }
                    catch (error) {
                    }
                });
                this.emitdata();
            }
        }
        catch (error) {
        }
    }
    ngOnInit() {
        this.selectedItem = [];
        setTimeout(() => {
            this.setControlWidths();
        }, 100);
    }
    keypress(event) {
        if (this.showDropdown == false) {
            this.showDropdown = true;
        }
        this._value = $('#' + this.controlName).val();
        if (event.keyCode == 38) { // up key
            if (this.currentIndex > 0) {
                this.currentIndex = this.currentIndex - 1;
            }
            else {
                this.currentIndex = this.data.length - 1;
            }
        }
        else if (event.keyCode == 40) { // down key
            if (this.filterdata.length - 1 > this.currentIndex) {
                this.currentIndex = this.currentIndex + 1;
            }
            else {
                this.currentIndex = 0;
            }
        }
        else if (event.keyCode == 37) { // left key
        }
        else if (event.keyCode == 39) { // right key
        }
        else if (event.keyCode == 45) { // delete key
        }
        else if (event.keyCode == 46) { // insert key
        }
        else if (event.shiftKey) { // shift key
        }
        else if (event.altKey) { // alt key
        }
        else if (event.ctrlKey) { // ctrl key
        }
        else if (event.metaKey) { // meta key
        }
        else if (event.keyCode == 120) { // home key
        }
        else if (event.keyCode == 121) { // end key
        }
        else if (event.keyCode == 8) { // end key
            if (this._value == '') {
                let item = this.returndata.split(',');
                // this._value=item[item.length-1];
                item.splice(item.length - 1, 1);
                this.returndata = item.toString();
                this.emitdata();
            }
        }
        else {
            this.loadData();
        }
    }
    keydown(event) {
        if (event.key === 'Enter') {
            if (this.selectedItem.filter(x => x[this.valueMember] == this.data[this.currentIndex][this.valueMember]).length <= 0) {
                this.selectedItem.push({ id: this.data[this.currentIndex][this.valueMember], name: this.data[this.currentIndex][this.displaymember] });
                this.emitdata();
            }
            this.showDropdown = false;
            event.stopPropagation();
            return false;
        }
    }
    loadData() {
        this.filterdata = this.data.filter(x => x[this.displaymember].indexOf(this._value) > -1);
    }
    removeselectedItem(item) {
        this.selectedItem.splice(this.selectedItem.indexOf(item), 1);
    }
    emitdata() {
        let _returndata = '';
        for (let i = 0; i < this.selectedItem.length; i++) {
            const element = this.selectedItem[i];
            if (_returndata == '') {
                _returndata = this.selectedItem[i][this.valueMember];
            }
            else {
                _returndata = _returndata + ',' + this.selectedItem[i][this.valueMember];
            }
        }
        this.returndata = _returndata;
        this.change.emit({ id: this.returndata });
        this.setControlWidths();
    }
    mouseclick(index) {
        this.currentIndex = index;
        if (this.selectedItem.filter(x => x[this.valueMember] == this.data[this.currentIndex][this.valueMember]).length <= 0) {
            this.selectedItem.push({ id: this.data[this.currentIndex][this.valueMember], name: this.data[this.currentIndex][this.displaymember] });
        }
        this.emitdata();
        this.showDropdown = false;
    }
    divclick() {
        $('#' + this.controlName).focus();
        this.setControlWidths();
        this.filterdata = this.data;
        if (this.showDropdown == false) {
            this.showDropdown = true;
            return;
        }
    }
    focusIn() {
        this.setControlWidths();
        this.filterdata = this.data;
        if (this.showDropdown == false) {
            this.showDropdown = true;
            return;
        }
    }
    focusout() {
        let frm = this;
        setTimeout(() => {
            frm.showDropdown = false;
        }, 1000);
    }
    scrollPosFunction() {
        try {
            let elmnt = document.getElementById('ctmdropdown');
            this.scrollHeight = elmnt.scrollHeight;
            if (this.scrollHeight > 0 && this.data.length > 0) {
                let eachComponentHeight = this.scrollHeight / this.data.length;
                document.getElementById('ctmdropdown').scrollTop = eachComponentHeight * this.currentIndex;
            }
        }
        catch (error) {
            console.log(error);
        }
    }
    setControlWidths() {
        let divheight = document.getElementById(this.controlName + 'div').offsetHeight;
        // var divwidth=document.getElementById(this.controlName+"div").offsetWidth;
        // var spanheight=document.getElementById(this.controlName+"span").offsetHeight;
        // document.getElementById(this.controlName+"control").style.width=(divwidth-spanheight)+"px";
        document.getElementById(this.controlName + 'divdropdown').style.top = (divheight + 30) + 'px';
    }
}
CdmulitselectComponent.ɵfac = function CdmulitselectComponent_Factory(t) { return new (t || CdmulitselectComponent)(); };
CdmulitselectComponent.ɵcmp = ɵɵdefineComponent({ type: CdmulitselectComponent, selectors: [["lib-cdmulitselect"]], inputs: { returnkey: ["modelkey", "returnkey"], data: ["datasource", "data"], valueMember: ["valuemember", "valueMember"], displaymember: "displaymember", form: "form", _formcontrolname: ["formcontrolname", "_formcontrolname"] }, outputs: { change: "change" }, features: [ɵɵNgOnChangesFeature], decls: 9, vars: 12, consts: [[1, "form-control", 2, "float", "left", 3, "formGroup", "id", "click"], [2, "float", "left", 3, "id"], [4, "ngIf"], [2, "float", "left"], ["type", "text", "tabindex", "0", "autocomplete", "off", "autocorrect", "off", "placeholder", "", "aria-autocomplete", "none", "autocomplete", "none", 2, "border", "none", "background-color", "transparent", 3, "name", "id", "focusout", "focusin", "keyup", "keydown"], ["type", "text", 1, "form-control", 2, "display", "none", 3, "ngModel", "formControlName", "name", "ngModelChange"], [2, "width", "96%", "position", "absolute", "z-index", "1000000", "top", "70px", "color", "black", "background-color", "wheat", 3, "id", "hidden"], [2, "width", "100%"], ["style", "cursor: pointer;", 3, "click", 4, "ngFor", "ngForOf"], ["style", "cursor: pointer;border: 2px solid rgb(2, 50, 117);border-radius: 4px;", 4, "ngFor", "ngForOf"], [2, "cursor", "pointer", "border", "2px solid rgb(2, 50, 117)", "border-radius", "4px"], [2, "cursor", "pointer", "color", "rgb(2, 50, 117)"], [3, "click"], [2, "cursor", "pointer", 3, "click"], [2, "cursor", "pointer", "text-align", "left !important", 3, "ngStyle"]], template: function CdmulitselectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵlistener("click", function CdmulitselectComponent_Template_div_click_0_listener() { return ctx.divclick(); });
        ɵɵelementStart(1, "div", 1);
        ɵɵtemplate(2, CdmulitselectComponent_span_2_Template, 2, 1, "span", 2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "div", 3);
        ɵɵelementStart(4, "input", 4);
        ɵɵlistener("focusout", function CdmulitselectComponent_Template_input_focusout_4_listener() { return ctx.focusout(); })("focusin", function CdmulitselectComponent_Template_input_focusin_4_listener() { return ctx.focusIn(); })("keyup", function CdmulitselectComponent_Template_input_keyup_4_listener($event) { return ctx.keypress($event); })("keydown", function CdmulitselectComponent_Template_input_keydown_4_listener($event) { return ctx.keydown($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(5, "input", 5);
        ɵɵlistener("ngModelChange", function CdmulitselectComponent_Template_input_ngModelChange_5_listener($event) { return ctx.returndata = $event; });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(6, "div", 6);
        ɵɵelementStart(7, "table", 7);
        ɵɵtemplate(8, CdmulitselectComponent_tr_8_Template, 3, 4, "tr", 8);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵpropertyInterpolate("id", ctx.controlName + "div");
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(1);
        ɵɵpropertyInterpolate("id", ctx.controlName + "span");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.selectedItem.length > 0);
        ɵɵadvance(2);
        ɵɵproperty("name", ctx.controlName)("id", ctx.controlName);
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.returndata)("formControlName", ctx._formcontrolname)("name", ctx._formcontrolname);
        ɵɵadvance(1);
        ɵɵpropertyInterpolate("id", ctx.controlName + "divdropdown");
        ɵɵproperty("hidden", !ctx.showDropdown);
        ɵɵadvance(2);
        ɵɵproperty("ngForOf", ctx.filterdata);
    } }, directives: [NgControlStatusGroup, FormGroupDirective, NgIf, DefaultValueAccessor, NgControlStatus, FormControlName, NgForOf, NgStyle], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CdmulitselectComponent, [{
        type: Component,
        args: [{
                selector: 'lib-cdmulitselect',
                templateUrl: './cdmulitselect.component.html',
                styleUrls: ['./cdmulitselect.component.css']
            }]
    }], function () { return []; }, { returnkey: [{
            type: Input,
            args: ['modelkey']
        }], data: [{
            type: Input,
            args: ['datasource']
        }], valueMember: [{
            type: Input,
            args: ['valuemember']
        }], displaymember: [{
            type: Input,
            args: ['displaymember']
        }], form: [{
            type: Input
        }], _formcontrolname: [{
            type: Input,
            args: ['formcontrolname']
        }], change: [{
            type: Output
        }] }); })();

function CdGridComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 3);
    ɵɵelementStart(1, "a", 4);
    ɵɵlistener("click", function CdGridComponent_div_4_Template_a_click_1_listener() { ɵɵrestoreView(_r2); const ctx_r1 = ɵɵnextContext(); return ctx_r1.FirstPage(); });
    ɵɵtext(2, " First");
    ɵɵelementEnd();
    ɵɵelementStart(3, "a", 4);
    ɵɵlistener("click", function CdGridComponent_div_4_Template_a_click_3_listener() { ɵɵrestoreView(_r2); const ctx_r3 = ɵɵnextContext(); return ctx_r3.PrevPage(); });
    ɵɵtext(4, "Prev");
    ɵɵelementEnd();
    ɵɵelementStart(5, "a", 5);
    ɵɵtext(6);
    ɵɵelementEnd();
    ɵɵelementStart(7, "a", 4);
    ɵɵlistener("click", function CdGridComponent_div_4_Template_a_click_7_listener() { ɵɵrestoreView(_r2); const ctx_r4 = ɵɵnextContext(); return ctx_r4.NextPage(); });
    ɵɵtext(8, "Next");
    ɵɵelementEnd();
    ɵɵelementStart(9, "a", 4);
    ɵɵlistener("click", function CdGridComponent_div_4_Template_a_click_9_listener() { ɵɵrestoreView(_r2); const ctx_r5 = ɵɵnextContext(); return ctx_r5.LastPage(); });
    ɵɵtext(10, "Last");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(6);
    ɵɵtextInterpolate2(" ", ctx_r0.currentPageNo + 1, " Of ", ctx_r0.Pages.length, " ");
} }
const _c0$2 = function (a0) { return { records: a0 }; };
class CdGridComponent {
    constructor() {
        this.currentPageNo = 0;
        this.PageCount = 0;
        this.PageNos = [];
        this.FirstPageNo = 1;
        this.LastPageNo = 4;
        this.pressed = false;
    }
    ngAfterViewInit() {
        $(this.cdbody.nariveElement);
    }
    ngOnChanges(changes) {
        this.PageCount = Math.ceil(this.datasource.length / this.recordrerpage);
        let RecordNumber = 0;
        this.Pages = [];
        this.PageNos = [];
        for (let i = 0; i < this.PageCount; i++) {
            this.Pages.push(new Array());
            this.PageNos.push(i);
            let k = 0;
            for (let j = RecordNumber; j < this.datasource.length; j++) {
                this.Pages[this.Pages.length - 1].push(this.datasource[j]);
                RecordNumber++;
                k++;
                if (k >= this.recordrerpage) {
                    break;
                }
            }
        }
    }
    ngOnInit() {
    }
    FirstPage() {
        this.currentPageNo = 0;
    }
    PrevPage() {
        if (this.currentPageNo > 0) {
            this.currentPageNo = this.currentPageNo - 1;
        }
    }
    NextPage() {
        if (this.currentPageNo < this.Pages.length - 1) {
            this.currentPageNo = this.currentPageNo + 1;
        }
    }
    LastPage() {
        this.currentPageNo = this.Pages.length - 1;
    }
}
CdGridComponent.ɵfac = function CdGridComponent_Factory(t) { return new (t || CdGridComponent)(); };
CdGridComponent.ɵcmp = ɵɵdefineComponent({ type: CdGridComponent, selectors: [["lib-cd-grid"]], contentQueries: function CdGridComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵɵcontentQuery(dirIndex, TemplateRef, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.cdbody = _t.first);
    } }, inputs: { datasource: "datasource", recordrerpage: "recordrerpage" }, features: [ɵɵNgOnChangesFeature], decls: 5, vars: 5, consts: [[1, "table", "table-bordered", "table-sm", "table-striped", "table-hover", "font-12", "cd-table", "table-fixed"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "pagination", 4, "ngIf"], [1, "pagination"], [1, "btn", "btn-secondary", 3, "click"], [1, "btn", "btn-secondary"]], template: function CdGridComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div");
        ɵɵelementStart(1, "table", 0);
        ɵɵelementStart(2, "template", 1);
        ɵɵtext(3, "\n        ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(4, CdGridComponent_div_4_Template, 11, 2, "div", 2);
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵproperty("ngTemplateOutlet", ctx.cdbody)("ngTemplateOutletContext", ɵɵpureFunction1(3, _c0$2, ctx.Pages[ctx.currentPageNo]));
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.PageCount > 1);
    } }, directives: [NgTemplateOutlet, NgIf], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CdGridComponent, [{
        type: Component,
        args: [{
                selector: 'lib-cd-grid',
                templateUrl: './cd-grid.component.html',
                styleUrls: ['./cd-grid.component.css']
            }]
    }], function () { return []; }, { datasource: [{
            type: Input
        }], recordrerpage: [{
            type: Input
        }], cdbody: [{
            type: ContentChild,
            args: [TemplateRef]
        }] }); })();

class CdDragDropDirective {
    constructor() { }
    onDragOver(event) {
        event.preventDefault();
        return false;
    }
    onDrop(event) {
    }
    onDropLeave(event) {
    }
}
CdDragDropDirective.ɵfac = function CdDragDropDirective_Factory(t) { return new (t || CdDragDropDirective)(); };
CdDragDropDirective.ɵdir = ɵɵdefineDirective({ type: CdDragDropDirective, selectors: [["", "libCdDragDrop", ""]], hostBindings: function CdDragDropDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("dragover", function CdDragDropDirective_dragover_HostBindingHandler($event) { return ctx.onDragOver($event); })("drop", function CdDragDropDirective_drop_HostBindingHandler($event) { return ctx.onDrop($event); })("dragstart", function CdDragDropDirective_dragstart_HostBindingHandler($event) { return ctx.onDropLeave($event); });
    } }, inputs: { DataSource: "DataSource" } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CdDragDropDirective, [{
        type: Directive,
        args: [{
                selector: '[libCdDragDrop]'
            }]
    }], function () { return []; }, { DataSource: [{
            type: Input
        }], onDragOver: [{
            type: HostListener,
            args: ['dragover', ['$event']]
        }], onDrop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }], onDropLeave: [{
            type: HostListener,
            args: ['dragstart', ['$event']]
        }] }); })();

const _c0$3 = ["div"];
function PaginationComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 3);
    ɵɵelementStart(1, "a", 4);
    ɵɵlistener("click", function PaginationComponent_div_4_Template_a_click_1_listener() { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return ctx_r2.FirstPage(); });
    ɵɵtext(2, " <<");
    ɵɵelementEnd();
    ɵɵelementStart(3, "a", 4);
    ɵɵlistener("click", function PaginationComponent_div_4_Template_a_click_3_listener() { ɵɵrestoreView(_r3); const ctx_r4 = ɵɵnextContext(); return ctx_r4.PrevPage(); });
    ɵɵtext(4, "< ");
    ɵɵelementEnd();
    ɵɵelementStart(5, "a", 5);
    ɵɵtext(6);
    ɵɵelementEnd();
    ɵɵelementStart(7, "a", 4);
    ɵɵlistener("click", function PaginationComponent_div_4_Template_a_click_7_listener() { ɵɵrestoreView(_r3); const ctx_r5 = ɵɵnextContext(); return ctx_r5.NextPage(); });
    ɵɵtext(8, ">");
    ɵɵelementEnd();
    ɵɵelementStart(9, "a", 4);
    ɵɵlistener("click", function PaginationComponent_div_4_Template_a_click_9_listener() { ɵɵrestoreView(_r3); const ctx_r6 = ɵɵnextContext(); return ctx_r6.LastPage(); });
    ɵɵtext(10, ">>");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(6);
    ɵɵtextInterpolate2(" ", ctx_r1.currentPageNo + 1, " / ", ctx_r1.Pages.length, " ");
} }
const _c1 = function (a0) { return { records: a0 }; };
class PaginationComponent {
    constructor() {
        this.currentPageNo = 0;
        this.PageCount = 0;
        this.PageNos = [];
        this.FirstPageNo = 1;
        this.LastPageNo = 4;
        this.pressed = false;
    }
    ngOnChanges(changes) {
        this.PageCount = Math.ceil(this.datasource.length / this.recordrerpage);
        let RecordNumber = 0;
        this.Pages = [];
        this.PageNos = [];
        for (let i = 0; i < this.PageCount; i++) {
            this.Pages.push(new Array());
            this.PageNos.push(i);
            let k = 0;
            for (let j = RecordNumber; j < this.datasource.length; j++) {
                this.Pages[this.Pages.length - 1].push(this.datasource[j]);
                RecordNumber++;
                k++;
                if (k >= this.recordrerpage) {
                    break;
                }
            }
        }
        let _this = this;
        setTimeout(() => {
            $.each($(_this.div.nativeElement).find('.cd-table').find('th'), function (index, value) {
                _this.start = this;
                let indx = $(this).index();
                $.each($(_this.div.nativeElement).find('.cd-table').find('td').parent('tr').parent('tbody').find('tr'), function (index1, value1) {
                    $(this).find('td').eq(indx).width($(_this.start).width());
                });
            });
        }, 1000);
    }
    ngOnInit() {
        let _this = this;
        setTimeout(() => {
            $(_this.div.nativeElement).find('.cd-table').find('th').mousedown(function (e) {
                _this.start = $(this);
                _this.pressed = true;
                _this.startX = e.pageX;
                _this.startWidth = $(this).width();
                _this.tableWidth = $(_this.div.nativeElement).find('.cd-table').width();
            });
            $(document).mousemove(function (e) {
                if (_this.pressed) {
                    if (_this.startWidth + (e.pageX - _this.startX) > 10) {
                        $(_this.start).width(_this.startWidth + (e.pageX - _this.startX));
                        let indx = $(_this.start).index();
                        $.each($(_this.div.nativeElement).find('.cd-table').find('td').parent('tr').parent('tbody').find('tr'), function (index, value) {
                            $(this).find('td').eq(indx).width($(_this.start).width());
                        });
                        // $(".cd-table").find("td").eq(indx).width($(_this.start).width());
                        $(_this.div.nativeElement).find('.cd-table').find('td').eq(indx).parent('tr').parent('thead').width($(_this.start).parent('tr').parent('thead').width());
                        $(_this.div.nativeElement).find('.cd-table').width(_this.tableWidth + (e.pageX - _this.startX));
                    }
                }
            });
            $(document).mouseup(function () {
                if (_this.pressed) {
                    _this.pressed = false;
                }
            });
            $(_this.div.nativeElement).find('.cd-table').find('th').mousemove(function (e) {
                if (!_this.pressed && e.offsetX < $(this).innerWidth() - 10) {
                    $(this).css('cursor', 'pointer');
                }
                else if (!_this.pressed && e.offsetX > $(this).innerWidth() - 10) {
                    $(this).css('cursor', 'ew-resize');
                }
            });
        }, 2000);
    }
    FirstPage() {
        this.currentPageNo = 0;
    }
    PrevPage() {
        if (this.currentPageNo > 0) {
            this.currentPageNo = this.currentPageNo - 1;
        }
    }
    NextPage() {
        if (this.currentPageNo < this.Pages.length - 1) {
            this.currentPageNo = this.currentPageNo + 1;
        }
    }
    LastPage() {
        this.currentPageNo = this.Pages.length - 1;
    }
}
PaginationComponent.ɵfac = function PaginationComponent_Factory(t) { return new (t || PaginationComponent)(); };
PaginationComponent.ɵcmp = ɵɵdefineComponent({ type: PaginationComponent, selectors: [["app-pagination"]], contentQueries: function PaginationComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵɵcontentQuery(dirIndex, TemplateRef, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.templ = _t.first);
    } }, viewQuery: function PaginationComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$3, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.div = _t.first);
    } }, inputs: { datasource: "datasource", recordrerpage: "recordrerpage" }, features: [ɵɵNgOnChangesFeature], decls: 5, vars: 5, consts: [["div", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "pagination", 4, "ngIf"], [1, "pagination"], [1, "btn", "btn-secondary", 3, "click"], [1, "btn", "btn-secondary"]], template: function PaginationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", null, 0);
        ɵɵelementStart(2, "template", 1);
        ɵɵtext(3, "\n");
        ɵɵelementEnd();
        ɵɵtemplate(4, PaginationComponent_div_4_Template, 11, 2, "div", 2);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵproperty("ngTemplateOutlet", ctx.templ)("ngTemplateOutletContext", ɵɵpureFunction1(3, _c1, ctx.Pages[ctx.currentPageNo]));
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.PageCount > 1);
    } }, directives: [NgTemplateOutlet, NgIf], styles: [".pagination[_ngcontent-%COMP%]{display:inline-block}.pagination[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:grey!important;margin-right:5px;background:0 0;border:none;font-size:15px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PaginationComponent, [{
        type: Component,
        args: [{
                selector: 'app-pagination',
                templateUrl: './pagination.component.html',
                styleUrls: ['./pagination.component.css']
            }]
    }], function () { return []; }, { div: [{
            type: ViewChild,
            args: ['div']
        }], datasource: [{
            type: Input
        }], recordrerpage: [{
            type: Input
        }], templ: [{
            type: ContentChild,
            args: [TemplateRef]
        }] }); })();

class AppSwitchComponent {
    constructor() {
        this.change = new EventEmitter();
        this.controlName = 'my' + Math.floor(Math.random() * 100);
    }
    ngOnInit() {
    }
    toggleValue() {
        this._value = !this._value;
        this.change.emit(this._value);
    }
}
AppSwitchComponent.ɵfac = function AppSwitchComponent_Factory(t) { return new (t || AppSwitchComponent)(); };
AppSwitchComponent.ɵcmp = ɵɵdefineComponent({ type: AppSwitchComponent, selectors: [["lib-app-switch"]], inputs: { _value: "_value" }, outputs: { change: "change" }, decls: 3, vars: 3, consts: [[1, "g-checkbox", "ng-isolate-scope", "ng-valid", "ng-not-empty", 2, "display", "inline-flex", 3, "ngClass", "click"], ["type", "button", "tabindex", "483", "wfd-id", "1084"], ["type", "checkbox", 1, "form-control", 2, "display", "none", 3, "ngModel", "name", "ngModelChange"]], template: function AppSwitchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵlistener("click", function AppSwitchComponent_Template_div_click_0_listener() { return ctx.toggleValue(); });
        ɵɵelementStart(1, "button", 1);
        ɵɵelementStart(2, "input", 2);
        ɵɵlistener("ngModelChange", function AppSwitchComponent_Template_input_ngModelChange_2_listener($event) { return ctx._value = $event; });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngClass", ctx._value == true ? "checked" : "");
        ɵɵadvance(2);
        ɵɵproperty("ngModel", ctx._value)("name", ctx.controlName);
    } }, directives: [NgClass, CheckboxControlValueAccessor, NgControlStatus, NgModel], styles: [".g-checkbox[_ngcontent-%COMP%]{vertical-align:bottom;margin-left:5px}.g-checkbox.checked[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{background:url(../assets/img/check.png) 0 0/contain no-repeat;width:17px;height:16px;border:0}.g-checkbox[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{background:url(../assets/img/uncheck.png) 0 0/contain no-repeat;width:17px;height:16px;border:0}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AppSwitchComponent, [{
        type: Component,
        args: [{
                selector: 'lib-app-switch',
                templateUrl: './app-switch.component.html',
                styleUrls: ['./app-switch.component.css']
            }]
    }], function () { return []; }, { _value: [{
            type: Input,
            args: ['_value']
        }], change: [{
            type: Output
        }] }); })();

function CustomDropdownComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 8);
    ɵɵelement(1, "img", 9);
    ɵɵelementEnd();
} }
function CustomDropdownComponent_tr_8_td_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "td");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ɵɵnextContext().$implicit;
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1("", item_r2[ctx_r3.displaymember1], " ");
} }
function CustomDropdownComponent_tr_8_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "tr", 10);
    ɵɵlistener("click", function CustomDropdownComponent_tr_8_Template_tr_click_0_listener() { ɵɵrestoreView(_r6); const item_r2 = ctx.$implicit; const ctx_r5 = ɵɵnextContext(); ctx_r5.SelectClient(item_r2); return ctx_r5.myFunction(); });
    ɵɵelementStart(1, "td");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵtemplate(3, CustomDropdownComponent_tr_8_td_3_Template, 2, 1, "td", 11);
    ɵɵelement(4, "td");
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate(item_r2[ctx_r1.displaymember]);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.displaymember1 != null && ctx_r1.displaymember1 != undefined);
} }
class CustomDropdownComponent {
    constructor() {
        this.selectedChange = new EventEmitter();
        this.SearchChange = new EventEmitter();
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
    }
    SelectClient(item) {
        this.selectedClient = item;
        this.selectedChange.emit(item);
    }
    myFunction() {
        document.getElementById('myDropdown').classList.toggle('show');
        document.getElementById('SearchText').focus();
    }
    LoadList(event) {
        // if (event.keyCode == 13) {
        this.SearchChange.emit(this.SearchText);
        // }
    }
}
CustomDropdownComponent.ɵfac = function CustomDropdownComponent_Factory(t) { return new (t || CustomDropdownComponent)(); };
CustomDropdownComponent.ɵcmp = ɵɵdefineComponent({ type: CustomDropdownComponent, selectors: [["lib-custom-dropdown"]], inputs: { dataSource: "dataSource", showloading: "showloading", displaymember: "displaymember", displaymember1: "displaymember1" }, outputs: { selectedChange: "selectedChange", SearchChange: "SearchChange" }, features: [ɵɵNgOnChangesFeature], decls: 9, vars: 4, consts: [[1, "dropbtn", "form-control", 2, "background-color", "transparent !important", "white-space", "nowrap", "overflow", "hidden", "text-overflow", "ellipsis", "font-size", "12px", 3, "click"], ["id", "myDropdown", 1, "dropdown-content", 2, "overflow", "auto"], ["type", "text", "placeholder", "Search..", "name", "SearchText", "id", "SearchText", 1, "form-control", 3, "ngModel", "ngModelChange", "keydown"], ["style", "position: absolute;;z-index: 1000000;right: 15px;top:30px;", 4, "ngIf"], [1, "input-group", "input-group-sm", "mb-1"], [2, "min-height", "100%", "height", "200px"], [1, "table", "table-borderd", 2, "text-transform", "uppercase"], [3, "click", 4, "ngFor", "ngForOf"], [2, "position", "absolute", ";z-index", "1000000", "right", "15px", "top", "30px"], ["width", "30", "height", "30", "src", "/assets/img/small.loading.gif"], [3, "click"], [4, "ngIf"]], template: function CustomDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "button", 0);
        ɵɵlistener("click", function CustomDropdownComponent_Template_button_click_0_listener() { return ctx.myFunction(); });
        ɵɵtext(1);
        ɵɵelementEnd();
        ɵɵelementStart(2, "div", 1);
        ɵɵelementStart(3, "input", 2);
        ɵɵlistener("ngModelChange", function CustomDropdownComponent_Template_input_ngModelChange_3_listener($event) { return ctx.SearchText = $event; })("keydown", function CustomDropdownComponent_Template_input_keydown_3_listener($event) { return ctx.LoadList($event); });
        ɵɵelementEnd();
        ɵɵtemplate(4, CustomDropdownComponent_div_4_Template, 2, 0, "div", 3);
        ɵɵelementStart(5, "div", 4);
        ɵɵelementStart(6, "div", 5);
        ɵɵelementStart(7, "table", 6);
        ɵɵtemplate(8, CustomDropdownComponent_tr_8_Template, 5, 2, "tr", 7);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵtextInterpolate1(" ", ctx.selectedClient != null && ctx.selectedClient != undefined ? ctx.selectedClient[ctx.displaymember] : "Select Client", "\n");
        ɵɵadvance(2);
        ɵɵproperty("ngModel", ctx.SearchText);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showloading);
        ɵɵadvance(4);
        ɵɵproperty("ngForOf", ctx.dataSource);
    } }, directives: [DefaultValueAccessor, NgControlStatus, NgModel, NgIf, NgForOf], styles: [".dropbtn[_ngcontent-%COMP%]{color:#000;padding:1px;font-size:16px;border:none;cursor:pointer;width:282px!important;text-transform:capitalize}.dropbtn[_ngcontent-%COMP%]:focus, .dropbtn[_ngcontent-%COMP%]:hover{background-color:grey;border:none}#SearchText[_ngcontent-%COMP%]{box-sizing:border-box;background-image:url(assets/img/searchicon.png);background-position:14px 12px;background-repeat:no-repeat;font-size:16px;padding:14px 20px 12px 45px;border:none;border-bottom:1px solid #ddd}#SearchText[_ngcontent-%COMP%]:focus{outline:#ddd solid 3px}.dropdown[_ngcontent-%COMP%]{position:relative;display:inline-block}.dropdown-content[_ngcontent-%COMP%]{display:none;position:absolute;background-color:#f6f6f6;min-width:230px;overflow:auto;border:1px solid #ddd;z-index:10;text-transform:capitalize}.dropdown-content[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#000;padding:12px 16px;text-decoration:none;display:block}.dropdown[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{background-color:#ddd}.show[_ngcontent-%COMP%]{display:block}.dropdown[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{font-size:12px}table[_ngcontent-%COMP%]{padding:2px!important}td[_ngcontent-%COMP%]{font-size:12px!important}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CustomDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'lib-custom-dropdown',
                templateUrl: './custom-dropdown.component.html',
                styleUrls: ['./custom-dropdown.component.css']
            }]
    }], function () { return []; }, { dataSource: [{
            type: Input
        }], showloading: [{
            type: Input
        }], displaymember: [{
            type: Input
        }], displaymember1: [{
            type: Input
        }], selectedChange: [{
            type: Output
        }], SearchChange: [{
            type: Output
        }] }); })();

class ServiceCommonModule {
    static forRoot() {
        return {
            ngModule: ServiceCommonModule,
            providers: [
                ServiceCommonService,
                EnvironmentService,
                FormValidationService,
                RestService, loaderserice, loaderBroadcaster, alertserice, AltBroadcaster, DropDownService
            ]
        };
    }
}
ServiceCommonModule.ɵmod = ɵɵdefineNgModule({ type: ServiceCommonModule });
ServiceCommonModule.ɵinj = ɵɵdefineInjector({ factory: function ServiceCommonModule_Factory(t) { return new (t || ServiceCommonModule)(); }, imports: [[
            HttpClientModule,
            CommonModule, FormsModule, ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ServiceCommonModule, { declarations: [ServiceCommonComponent, loader, alert, CDDropdownComponent, CdmulitselectComponent, CdGridComponent, CdDragDropDirective, PaginationComponent, AppSwitchComponent, CustomDropdownComponent], imports: [HttpClientModule,
        CommonModule, FormsModule, ReactiveFormsModule], exports: [ServiceCommonComponent, loader, alert, CDDropdownComponent, CdmulitselectComponent, CdGridComponent, PaginationComponent, AppSwitchComponent, CustomDropdownComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ServiceCommonModule, [{
        type: NgModule,
        args: [{
                declarations: [ServiceCommonComponent, loader, alert, CDDropdownComponent, CdmulitselectComponent, CdGridComponent, CdDragDropDirective, PaginationComponent, AppSwitchComponent, CustomDropdownComponent],
                imports: [
                    HttpClientModule,
                    CommonModule, FormsModule, ReactiveFormsModule
                ],
                exports: [ServiceCommonComponent, loader, alert, CDDropdownComponent, CdmulitselectComponent, CdGridComponent, PaginationComponent, AppSwitchComponent, CustomDropdownComponent]
            }]
    }], null, null); })();

class ErrorResponse {
    constructor(field, message) {
        this.field = field;
        this.message = message;
    }
    static get default() {
        return new ErrorResponse('', 'Something went wrong. Please try again later.');
    }
}

class RejectedResponse {
    constructor(rejected) {
        if (rejected) {
            this.statusCode = rejected.status;
            if (rejected.errors) {
                const errorObj = rejected.errors;
                if (errorObj.message) {
                    this.message = errorObj.message;
                }
                this.errors = [];
                for (const error of errorObj) {
                    if (error.message) {
                        this.errors.push(new ErrorResponse(error.field, error.message));
                    }
                }
            }
        }
    }
}

class WebSocketService {
    constructor(environment) {
        this.environment = environment;
        try {
            this.connection = new HubConnectionBuilder().withUrl(environment.getValue('ApiStocket') + '/chat').build();
        }
        catch (error) {
        }
        this.start();
    }
    start() {
        this.connection.start().then((result) => {
            console.log('success');
            this.sendMessage('Tarachand');
        }).catch(error => {
            console.log(error);
        });
    }
    close() {
        this.connection.start().then((result) => {
            console.log('disconnected');
        }).catch(error => {
            console.log(error);
        });
    }
    get value() {
        return this.connection;
    }
    sendMessage(toUserName) {
        this.connection.send('Register', toUserName);
    }
    receiveMessage() {
        /// this.connection.on()
    }
}
WebSocketService.ɵfac = function WebSocketService_Factory(t) { return new (t || WebSocketService)(ɵɵinject(EnvironmentService)); };
WebSocketService.ɵprov = ɵɵdefineInjectable({ token: WebSocketService, factory: WebSocketService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(WebSocketService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: EnvironmentService }]; }, null); })();

/*
 * Public API Surface of service-common
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AltBroadcaster, AppSwitchComponent, CDDropdownComponent, CdGridComponent, CdmulitselectComponent, CustomDropdownComponent, DropDownService, EnvironmentService, ErrorResponse, FormValidationService, PaginationComponent, RejectedResponse, RestService, ServiceCommonComponent, ServiceCommonModule, ServiceCommonService, WebSocketService, alert, alertBroadcastEventCls, alertserice, loader, loaderBroadcastEventCls, loaderBroadcaster, loaderserice };
//# sourceMappingURL=service-common.js.map
